import React from 'react'
import Text from 'react-text'
import Icon from '../icon'
import {Consumer} from '../../context'
import './filters.styl'

export default function Filters (props) {
  return (<Consumer>{ context => {
    const {assessmentCount} = context
    return (
      <div className="filters-wrapper">
        <div className="filters">
          <div className="label-wrapper">
            <div className="label">
              <div className="icon">
                <Icon name="lesson-count" />
              </div>
              <div className="count">
                { assessmentCount > 0 && (<React.Fragment>
                  <Text id="assessments_label" />: {assessmentCount}
                </React.Fragment>) }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }}</Consumer>)
}
